interface ICancelPortInPayload {
    mnpId: number;
}

export const getStateToPayload = (portInId: number): ICancelPortInPayload => ({ mnpId: portInId });
